import React, { Fragment, useState } from "react";
import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";
import { useDispatch } from "react-redux";
import { Col, Input, Label, Row } from "reactstrap";
import FilterInTable from "./FilterInTable";
import { MdTune } from "react-icons/md";

const ManageTable = (props) => {
    const dispatch = useDispatch();

    const propsData = props.propsData;
    const columns = props.columns;
    const data = props.tableData;
    const name = props.name;
    const can_create = props.can_create;
    const isSelectable = props.isSelectable;

    const getCustomStyles = (name) => {
        return {
            headCells: {
                style: {
                    backgroundColor: "#fafafa",
                    fontWeight: "700",
                    div: {
                        whiteSpace: "normal",
                        overflow: "visible",
                    },
                },
            },
            cells: {
                style: {
                    div: {
                        whiteSpace: "normal !important",
                        overflow: "visible !important",
                    },
                },
            },
        };
    };

    const customStyles = getCustomStyles(props.name);

    const [filteredData, setFilteredData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [searchs, setSearchs] = useState("");
    const [modal, setModal] = useState(false);

    const [showFilters, setShowFilters] = useState(false);
    const toggleFilters = () => setShowFilters(!showFilters);

    // const adminPagination=useSelector(state=>state.smeAdminTitleRedux.adminAllTutorialPagination)
    // useEffect(() => {
    //     // Log the default data whenever it changes
    //   }, [adminPagination]);

    // const handlePagination = (page, rowsPerPage) => {
    //     console.log('CALLED===', page, rowsPerPage)
    //       if(name == 'SME Admin Tutorial'){
    //         let obj = { page: page , pageSize: rowsPerPage, filter:"all", search_keyword:'', totalPages: adminPagination.totalPages}
    //         dispatch(adminAllTutorialPagination(obj))
    //         dispatch(Action.getSMEALLAdminTitleHandler(obj))
    //       }
    // if(name == 'SME Admin Approved Tutorial'){
    //     let obj = { page: page , pageSize: rowsPerPage, filter:"approved", search_keyword:'', totalPages: adminPagination.totalPages}
    //     dispatch(adminAllTutorialPagination(obj))
    //     dispatch(Action.getSMEApprovedAdminTitleHandler(obj))
    //   }

    //     }

    // const handleSearch = () => {
    //     if(name == 'SME Admin Tutorial'){
    //      const obb = {
    //        page: adminPagination.page ,
    //        pageSize: adminPagination.pageSize,
    //        filter:"all",
    //        search_keyword:searchs,
    //        totalPages: adminPagination.totalPages,
    //      }
    //       dispatch(Action.getSMEALLAdminTitleHandler(obb))
    //     }
    //     if(name == 'SME Admin Approved Tutorial'){
    //      const obb = {
    //        page: adminPagination.page ,
    //        pageSize: adminPagination.pageSize,
    //        filter:"approved",
    //        search_keyword:searchs,
    //        totalPages: adminPagination.totalPages,
    //      }
    //       dispatch(Action.getSMEApprovedAdminTitleHandler(obb))
    //     }

    //    };

    const handleModal = () => setModal(!modal);

    const handleFilter = (e) => {
        const value = e.target.value;
        const keys = data && data.length !== 0 && Object.keys(data[0]);

        let updatedData = [];
        setSearchValue(value);

        if (value.length && data && data.length !== 0) {
            updatedData = data.filter((item) => {
                let startsWith = keys.map((key) => {
                    return (
                        item[key] &&
                        item[key] !== null &&
                        item[key]?.toString().toLowerCase().startsWith(value.toLowerCase())
                    );
                });

                startsWith = startsWith.includes(true);

                let includes = keys.map((key) => {
                    return (
                        item[key] &&
                        item[key] !== null &&
                        item[key].toString().toLowerCase().includes(value.toLowerCase())
                    );
                });

                includes = includes.includes(true);

                if (startsWith) {
                    return startsWith;
                } else if (!startsWith && includes) {
                    return includes;
                } else return null;
            });
            setFilteredData(updatedData);
            setSearchValue(value);
        }
    };

    return (
        <>
            <Fragment>
                <Row>
                    {name === "All Coupons" ||
                        name === "Active Coupons" ||
                        name === "Deactivated Coupons" ||
                        name === "All Vouchers" ||
                        name === "Active Vouchers" ||
                        name === "Deactivated Vouchers" ||
                        name === "Order History" ||
                        name == "Return History" ||
                        name == "Interaction History" ||
                        name == "Followed Stores" ||
                        name == "Product Reviews" ||
                        name === "All Products" ||
                        name === "Active Products" ||
                        name === "Under Approval Products" ||
                        name === "Inactive Out of Stock Products" ||
                        name === "Inactive Restricted Products" ||
                        name === "Inactive Deleted Products" ||
                        name === "Pending Orders" ||
                        name === "Manage Platform Products" ||
                        name === "Manage Fulfillment SKU" ||
                        name === "Order Management" ||
                        name === "Maelano Wallet Activity" ? (
                        <div className="mb-2">
                            <div className="d-md-none text-end" onClick={toggleFilters}>
                                {showFilters ? "Hide" : "Filters"} <MdTune size={24} />
                            </div>
                            <div className={`d-${showFilters ? "block" : "none"} d-md-block`}>
                                <FilterInTable componentName={name} />
                            </div>
                        </div>
                    ) : (
                        <>
                            <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="d-flex justify-content-between align-items-center pl-2 mt-1 mb-1"
                            >
                                <>
                                    <Label className="mx-1" for="search-input">
                                        Search
                                    </Label>
                                    <Input
                                        className="dataTable-filter"
                                        type="text"
                                        bsSize="sm"
                                        id="search-input"
                                        value={searchValue}
                                        onChange={handleFilter}
                                    />
                                </>
                            </Col>

                            {/*  add, csv  */}
                            {/* <Col className='d-flex justify-content-end  ' style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    alignItems: "center", 
                                    marginRight: "1rem",
                                }}>
                                    {
                                        can_create === 1 ?
                                            <Button
                                                className="btn-icon"
                                                color="primary"
                                                outline
                                                // onClick={() => {resetStates();  setModal(true)}}
                                                onClick={() => setModal(true)}
                                            >
                                                <Plus size={15} />
                                            </Button> 
                                            : ''}
                                </Col> */}
                        </>
                    )}
                </Row>

                {name == "Interaction History" ? (
                    <> Total Interactions : {data?.length} </>
                ) : name == "Order History" ? (
                    <> Total Orders: {data?.length} </>
                ) : name == "Return History" ? (
                    <> Total Return Orders: {data?.length} </>
                ) : name == "Followed Stores" ? (
                    <> Total Stores Followed: {data?.length} </>
                ) : (
                    ""
                )}

                {
                    // name === 'Technical Review' || name === 'Final Review' ?
                    //             <DataTable
                    //               noHeader
                    //               fixedHeader
                    //               selectableRows
                    //               onSelectedRowsChange={handleRowSelected}
                    //               columns={columns}
                    //               theme={skin}
                    //               data={searchValue.length != 0 ? filteredData : data}
                    //               pagination={true}
                    //               paginationRowsPerPageOptions={[10, 15, 25, 50, 100]}
                    //               // paginationPerPage={5}
                    //               // paginationDefaultPage={currentPage + 1}
                    //               customStyles={customStyles}
                    //               sortIcon={<ChevronDown size={10} />}
                    //               conditionalRowStyles={props.conditionalRowStyles ? props.conditionalRowStyles : {}}

                    //               // paginationTotalRows={filteredData.length || data.length}

                    //               // paginationPerPage={10}
                    //               paginationTotalRows={
                    //                 ((name === "Technical Review" || name === "Final Review") ? adminPagination.totalPages :
                    //                   data.length)}

                    //               paginationPerPage={
                    //                 ((name === "Technical Review" || name === "Final Review") ? adminPagination.pageSize :
                    //                   10)}

                    //               onChangeRowsPerPage={(currentRowsPerPage, currentPage) => { handlePagination(currentPage, currentRowsPerPage); }
                    //               }
                    //               onChangePage={(currentPage) => {
                    //                 const dataPerPage = ((name === "Technical Review" || name === "Final Review")

                    //                   ? adminPagination.pageSize :
                    //                   10);
                    //                 // const dataPerPage = adminPagination.pageSize;
                    //                 handlePagination(currentPage, dataPerPage);
                    //               }}

                    //             />

                    // :
                    <DataTable
                        noHeader
                        fixedHeader
                        columns={columns}
                        data={searchValue.length != 0 ? filteredData : data}
                        pagination={true}
                        paginationRowsPerPageOptions={[10, 15, 25, 50, 100]}
                        // paginationPerPage={5}
                        // paginationDefaultPage={currentPage + 1}
                        customStyles={customStyles}
                        sortIcon={<ChevronDown size={10} />}
                        conditionalRowStyles={
                            props.conditionalRowStyles ? props.conditionalRowStyles : {}
                        }
                        paginationTotalRows={filteredData?.length || data?.length}
                        selectableRows={isSelectable}
                        paginationPerPage={10}
                    />
                }
            </Fragment>
        </>
    );
};

export default ManageTable;